var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$te(_vm.langPath))?_c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"ma-2 font-italic"},[_vm._v(" "+_vm._s(_vm.$t(_vm.langPath))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }